import {
  useEffect,
  useState,
} from 'react';

import { useSnackbar } from 'notistack';
import Dynamicore, { SERVICES } from 'services/dynamicore';
import { dynamicSort } from 'utils/arrays';

import {
  getSelectorTypes,
  replaceKeyInArray,
} from '../constants';

//Maneja la lógica de los selectores en cascada del alta de firmantes: tipo, cliente y relación.
export default function useSignerSelectors({ t }) {
  const { enqueueSnackbar } = useSnackbar();
  const selectorTypes = getSelectorTypes(t);
  const [selectorType, setSelectorType] = useState(t('forms.selectors.select'));
  const [selectorClients, setSelectorClients] = useState();
  const [selectorClient, setSelectorClient] = useState(
    t('forms.selectors.select'),
  );
  const [selectorRelationships, setSelectorRelationships] = useState();
  const [selectorRelationShip, setSelectorRelationShip] = useState(
    t('forms.selectors.select'),
  );
  const [isProcessing, setIsProcessing] = useState();
  const [valuesClient, setValuesClient] = useState();

  const loadClients = async function () {
    const {
      values = [],
      //total = 0,
    } = await Dynamicore(SERVICES.PEOPLE_TYPES).get();

    setSelectorClients(values.sort(dynamicSort('name')));
  };

  const loadRelationships = async function () {
    const {
      values = [],
      //total = 0,
    } = await Dynamicore(SERVICES.PEOPLE_RELATIONSHIP).get({
      enabled: true,
    });
    //{
    //  enabled: true,
    //}

    setSelectorRelationships(values.sort(dynamicSort('name')));
  };

  useEffect(() => {
    loadRelationships();
    loadClients();
  }, []);

  // Restablece los tres selectores al valor por defecto.
  const resetSelectors = function () {
    setSelectorType(t('forms.selectors.select'));
    setSelectorClient(t('forms.selectors.select'));
    setSelectorRelationShip(t('forms.selectors.select'));
  };

  const handleSelectorType = function (values) {
    setIsProcessing(true);

    const matchingConfig = selectorTypes.find(
      ({ id }) => id === parseInt(values.value, 10),
    );
    if (matchingConfig) {
      setSelectorType(matchingConfig?.id);
      setSelectorClient(t('forms.selectors.select'));
      setSelectorRelationShip(t('forms.selectors.select'));
    } else {
      setSelectorType(t('forms.selectors.select'));
      setSelectorClient(t('forms.selectors.select'));
      setSelectorRelationShip(t('forms.selectors.select'));
    }

    setTimeout(() => {
      setIsProcessing(false);
    }, 500);
  };

  const handleSelectorClient = async function (values) {
    setIsProcessing(true);

    const matchingConfig = selectorClients.find(
      ({ id }) => id === parseInt(values.value, 10),
    );

    if (matchingConfig) {
      setSelectorClient(matchingConfig?.id);

      try {
        const data = await Dynamicore(SERVICES.DOCUMENTS_TEMPLATES_CLIENTS).get(
          {
            type: 'client',
            type_id: matchingConfig?.id,
          },
        );

        const aux = replaceKeyInArray(data?.values, 'value', 'id');

        setValuesClient(aux.sort(dynamicSort('name')));
      } catch (error) {
        console.error('Error al cargar los datos del template:', error);
        return;
      }
    } else {
      setSelectorClient(t('forms.selectors.select'));
    }
    setIsProcessing(false);
  };

  const handleSelectorRelationships = async function (values) {
    setIsProcessing(true);

    const matchingConfig = selectorRelationships.find(
      ({ id }) => id === parseInt(values.value, 10),
    );
    if (matchingConfig) {
      setSelectorRelationShip(matchingConfig?.id);

      try {
        const data = await Dynamicore(SERVICES.DOCUMENTS_TEMPLATES_CLIENTS).get(
          {
            type: 'relationship',
            type_id: matchingConfig?.id,
          },
        );
        const allItems = data?.values.reduce((acc, item) => {
          Object.values(item).forEach((value) => {
            acc.push(...value);
          });
          return acc;
        }, []);
        const aux = replaceKeyInArray(allItems, 'value', 'id');
        setValuesClient(aux.sort(dynamicSort('name')));
      } catch (error) {
        enqueueSnackbar('Error al cargar los datos del template:', error);
        return;
      }
    } else {
      setSelectorRelationShip(t('forms.selectors.select'));
    }
    setIsProcessing(false);
  };

  return {
    selectorTypes,
    selectorType,
    selectorClients,
    selectorClient,
    selectorRelationships,
    selectorRelationShip,
    isProcessing,
    valuesClient,
    setSelectorType,
    setSelectorClient,
    setSelectorRelationShip,
    resetSelectors,
    handleSelectorType,
    handleSelectorClient,
    handleSelectorRelationships,
  };
}
